export enum OnlineMethodType {
    // -- DEPRECATED --
    // VISA = 'visa',
    // MASTERCARD = 'master',
    FPS = 'fps',// 202309
    PPS = 'pps',
    CREDIT_CARD = 'creditcard',
}
